export default __webpack_public_path__ + "static/default-accolades-c4287d6029099120a0b0e07720e28dd4.png";